import {GameInfo, OpenGameParameters} from '../games/game-info';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {SuggestedLinkConfiguration} from '../configurations/config-data-sections/game-search-box.configuration';
import {IMenuItemAction} from "../menu-item-action-factory/menu-item-action.interface";

export interface ISearchSuggestion {
  readonly key: string;
  readonly text: string;
  readonly linkIconClass: string;
  readonly type: string;
  readonly gameInfo: GameInfo | null;
  executeAction(): void;
}

export const SUGGESTED_CATEGORIES = "Suggested_Categories";


export class GameSuggestion implements ISearchSuggestion {
  constructor(private services: IServiceFactoryExtended,
              private _gameInfo: GameInfo,
              private _analyticsLabel: string,
              private _index?: number,
              private _aiSortingType?: string) {

  }

  get gameInfo(): GameInfo {
    return this._gameInfo;
  }

  get type(): string {
    return this._analyticsLabel;
  }

  get key(): string {
    return this._gameInfo.gameType + '_' + this._gameInfo.title;
  }

  get text(): string {
    return this._gameInfo.title;
  }

  get linkIconClass(): string {
    return this._gameInfo.gameCategory;
  }

  executeAction(): void {

    const openGameParams: OpenGameParameters = {
      isRealMode: true,
      pageName: 'Search',
      gameIndex: this._index,
      listTitle: this.type,
      aiSortingType: this._aiSortingType,
      showIntermediatePage: this.services.cmsSegmentation.isCstatus === false //Show intermediate page only for user with cStatus == false, TASK 1832892
    };

    this._gameInfo.open(openGameParams);
  }
}


export class SearchLinkSuggestion implements ISearchSuggestion {
  constructor(private _linkConfig: SuggestedLinkConfiguration,
              private services: IServiceFactoryExtended,
              private _analyticsAction: string) {
    if(this._linkConfig.menuItemKey) {
      this._menuItem = this.services.gameSearch.getMenuItemAction(this._linkConfig.menuItemKey);
    }
  }

  private readonly _menuItem: IMenuItemAction | null = null;

  get gameInfo(): GameInfo | null{
    return null;
  }

  get type(): string {
    return this._analyticsAction;
  }

  get key(): string {
    return this._linkConfig.text;
  }

  get text(): string {
    return this.services.translation.translate(this._linkConfig.text);
  }

  get linkIconClass(): string {
    return 'link';
  }

  executeAction() {
    this.services.analytics.sendAnalytics('Search', this.type, this.text);
    if(this._linkConfig.linkId) {
      this.services.linksNavigation.navigateLink({
        linkId: this._linkConfig.linkId,
        linkHash: this._linkConfig.linkHash
      });
    }
    else if(this._menuItem) {
      this._menuItem.execute({
        linkHash: this._linkConfig.linkHash
      });
    } else {
      this.services.logger.error(`Navigation for search suggestion link ${this.key} not specified`)
    }

  }
}


export class GameSearchResult {
  constructor(private _games: ISearchSuggestion[], private _suggestedCategories: ISearchSuggestion[], private _suggestedGames: ISearchSuggestion[]) {}

  get suggestedGames(): ISearchSuggestion[] {
    return this._suggestedGames;
  }

  get games(): ISearchSuggestion[] {
    return this._games;
  }

  get suggestedCategories(): ISearchSuggestion[] {
    return this._suggestedCategories;
  }
}
